import { Gui } from './../../../gui';
import { MapDrawInteractionUI } from './map-draw-interaction-ui';
import { MapDrawInteractionStyles } from './map-draw-interaction-styles';
import { SelectLocationCommandExecutor, SelectLocationCommandOutputParameters } from './../../../commands/select-location-command-executor';
import { DataLocationFilterParameters } from "../../../../data-management/data-filters/filters/data-location-filter";


export class MapDrawInteractionCircle {
    public feature: any;
    private enabled: boolean = true;

    constructor(private locationCommandExecutor: SelectLocationCommandExecutor, public gui: Gui, private parentui: MapDrawInteractionUI) {
        locationCommandExecutor.commandExecuted.attach(this.handleFilterUpdate);
        locationCommandExecutor.deleted.attach(this.handleFilterDelete);
    }

    public invokeDelete() {
        this.gui.commandManager.deleteLocationCommand(this.locationCommandExecutor);
    }

    public handleFilterUpdate = (parameters: SelectLocationCommandOutputParameters) => {
        // currently we only change on enabled here.
        MapDrawInteractionStyles.shapesDataIdsToActive[this.feature.getId()] = parameters.enabled;
        this.enabled = parameters.enabled;
        this.feature.getGeometry().setRadius(parameters.circleOL.radius);
        this.feature.getGeometry().setCenter([parameters.circleOL.x, parameters.circleOL.y]);
        this.feature.changed();
    }

    public handleFilterDelete = () => {
        this.parentui.removeCircle(this);
    }

    public getFilterParameters(): DataLocationFilterParameters {
        let center = this.feature.getGeometry().getCenter();
        let radius: number = this.feature.getGeometry().getRadius();
        let x: number = center[0];
        let y: number = center[1];

        return {
            circleOL: { x, y, radius },
            circle: null,
            enabled: this.enabled
        };
    }

}
